import { USER_LOAD, SET_TOKEN } from './actionTypes';
import { FAVORITE_STATISTIC } from '../Favorites/actionTypes';
import { START, SUCCESS, ERROR } from '../../consts';
import { fromJS } from 'immutable';

const DEFAULT_STATE = fromJS({
  loading: false,
  loaded: false,
  token: null,
  data: {},
  error: null
});

export default function user (state = DEFAULT_STATE, action) {
  switch (action.type) {
    case SET_TOKEN:
      return state.merge({
        token: action.payload
      });

    case USER_LOAD + START:
      return state.merge({
        loading: true,
        loaded: false,
        error: null,
        token: action.payload
      });

    case USER_LOAD + ERROR:
      return DEFAULT_STATE.merge({
        token: null,
        error: action.payload.message
      });

    case USER_LOAD + SUCCESS:
      return state.merge({
        loading: false,
        loaded: true,
        data: fromJS(action.payload)
      });

    case FAVORITE_STATISTIC + SUCCESS:
      return state.mergeIn(['data', 'favoritesStatistics'], fromJS(action.payload));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/User/reducer.js